export const tokenAndRoute = {
  computed: {
    token() {
      return this.$store.state.auth.token
    },
    routeId() {
      return this.$route.params.id
    },
    routeItem() {
      return this.$route.params.item
    }
  }
}
